import React from 'react';
import { Navigate } from 'react-router';

interface RootRedirectProps {
	initialLink: string;
	onInitialLinkRedirect: () => void;
}

export const RootRedirect: React.FC<RootRedirectProps> = ({
	initialLink,
	onInitialLinkRedirect,
}) => {
	if (initialLink) {
		onInitialLinkRedirect();
		return <Navigate to={initialLink} replace />;
	}

	return <Navigate to="/dashboard" replace />;
};
